module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/onesence-4-53e0ff4ac3a72cfea96e5461718bb567.webp";